import { render, staticRenderFns } from "./GrowingBranches.vue?vue&type=template&id=77e2ff34&scoped=true"
import script from "./GrowingBranches.vue?vue&type=script&lang=ts"
export * from "./GrowingBranches.vue?vue&type=script&lang=ts"
import style0 from "./GrowingBranches.vue?vue&type=style&index=0&id=77e2ff34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e2ff34",
  null
  
)

export default component.exports